
import React, { Component } from 'react';
import { SocialIcon } from 'react-social-icons';
//
class SocialLinks extends Component {
    constructor(props) {
        super(props);

        this.state = {
            socialLinks: [
                "https://open.spotify.com/show/0SXl1MguXWA5flAgvWb2in",
                "https://twitter.com/BluffDouble",
                "https://www.facebook.com/Double-Bluff-108169080922286",
                "https://www.instagram.com/doublebluffpod"
            ],
        }

    }

    render() {
        let links = [];
        this.state.socialLinks.forEach((url) => {
           links.push(
           <div className="social-container">
               <SocialIcon url={url} /> 
           </div>
           )
        });

        return (
            <div>
                {links}
            </div>
        )

    }
}
export default SocialLinks; 